export default "__VITE_ASSET__375aac69__"